// extracted by mini-css-extract-plugin
module.exports = {"lightInput":"LrvPassword_lightInput__2K6w2","darkInput":"LrvPassword_darkInput__zirTp"};